(function() {

  // ── LAY ON ME — Toevoeg popup ──────────────────────────────────────────
  // Onderschep theme:cart:popdown (na succesvolle ATC) en toon eigen popup.
  document.addEventListener('theme:cart:popdown', function(e) {
    e.stopImmediatePropagation();
    var popup = document.getElementById('lom-atc-popup');
    if (!popup) return;
    popup.style.display = 'flex';
    popup.setAttribute('aria-hidden', 'false');
    clearTimeout(popup._lomTimer);
    popup._lomTimer = setTimeout(function() {
      popup.style.display = 'none';
      popup.setAttribute('aria-hidden', 'true');
    }, 6000);
  }, true);

  // ── LAY ON ME — Premium homepage ──────────────────────────────────────

  // Alleen uitvoeren op homepage
  if (!document.body.classList.contains('template-index')) return;

  // ── Trust statistieken balk injecteren na hero sectie ──
  var heroSection = document.querySelector('[data-section-type="hero"]');
  if (heroSection) {
    var trustBar = document.createElement('div');
    trustBar.className = 'lom-trust-bar';
    trustBar.innerHTML =
      '<div class="lom-trust-bar__item">' +
        '<span class="lom-trust-bar__number">2.000+</span>' +
        '<span class="lom-trust-bar__label">Tevreden klanten</span>' +
      '</div>' +
      '<div class="lom-trust-bar__item">' +
        '<span class="lom-trust-bar__number">4.9★</span>' +
        '<span class="lom-trust-bar__label">Gemiddelde beoordeling</span>' +
      '</div>' +
      '<div class="lom-trust-bar__item">' +
        '<span class="lom-trust-bar__number">30+</span>' +
        '<span class="lom-trust-bar__label">Unieke designs</span>' +
      '</div>' +
      '<div class="lom-trust-bar__item">' +
        '<span class="lom-trust-bar__number">100%</span>' +
        '<span class="lom-trust-bar__label">Duurzaam materiaal</span>' +
      '</div>';
    heroSection.insertAdjacentElement('afterend', trustBar);
  }

  // ── Scroll-reveal via IntersectionObserver ──
  var revealObserver = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('lom-revealed');
        revealObserver.unobserve(entry.target);
      }
    });
  }, { threshold: 0.12 });

  // Voeg reveal klassen toe aan secties
  var revealTargets = [
    '.section-icons .icon__column',
    '.section-list-collections .grid__item',
    '.section-collection .product-grid-item',
    '.section-collection-slider .product-grid-item',
    '.mosaic__tile',
    '.section--double .brick__block',
    '.lom-trust-bar__item'
  ];

  revealTargets.forEach(function(selector) {
    document.querySelectorAll(selector).forEach(function(el, i) {
      el.classList.add('lom-reveal');
      var delayClass = 'lom-reveal-delay-' + Math.min(i % 4 + 1, 4);
      el.classList.add(delayClass);
      revealObserver.observe(el);
    });
  });

  // ── Sectie titels reveal ──
  document.querySelectorAll(
    '.section-collection h2, .section-collection-slider h2, .section-list-collections h2, .section-icons h2'
  ).forEach(function(el) {
    el.classList.add('lom-reveal');
    revealObserver.observe(el);
  });

})();
